module.exports = __webpack_public_path__ + "img/icon-info-general-dark.a6b1ef8.svg";